/* jshint esversion: 6, -W097 */
/* globals module */
'use strict';

/**
 * Creates an product card platforms instance
 *
 * @module enervee_utils.product_card
 */
function productCardPlatformsDirective() {
    return {
        restrict: 'E',
        scope: {
            product: '=',
        },
        template: require('./platformsView.html')
    };
}

module.exports = productCardPlatformsDirective;
